import {LocalizedText, ServiceNotice, ServiceNoticeSeverity} from './types'

const SEVERITIES: ServiceNoticeSeverity[] = ['info', 'warning', 'critical']

export const pickLocalizedText = (text: LocalizedText | string | null | undefined, language: string): string => {
  if (!text) {
    return ''
  }
  if (typeof text === 'string') {
    return text
  }
  const own = text[language]
  if (own) {
    return own
  }
  if (text.en) {
    return text.en
  }
  return Object.values(text).find((value): value is string => Boolean(value)) || ''
}

// Anything other than a well-formed notice (204 body, HTML error page, null) means "no notice".
export const parseServiceNotice = (data: unknown): ServiceNotice | null => {
  if (!data || typeof data !== 'object') {
    return null
  }
  const notice: Partial<ServiceNotice> = data
  const {id, title, message} = notice
  if (!id || !title || !message) {
    return null
  }
  const severity = SEVERITIES.find((value) => value === notice.severity) || 'info'
  return {...notice, id, title, message, severity}
}

const toTime = (value?: string | null): number | null => {
  if (!value) {
    return null
  }
  const time = Date.parse(value)
  return Number.isNaN(time) ? null : time
}

export const isServiceNoticeActive = (notice: ServiceNotice, now: number = Date.now()): boolean => {
  const startsAt = toTime(notice.startsAt)
  const endsAt = toTime(notice.endsAt)
  if (startsAt !== null && now < startsAt) {
    return false
  }
  return !(endsAt !== null && now >= endsAt)
}

export const getServiceNoticeDismissKey = (notice: ServiceNotice): string => `${notice.id}:${notice.updatedAt || ''}`

const DISMISSED_PREFIX = 'serviceNoticeDismissed:'

export const isServiceNoticeDismissed = (key: string): boolean => {
  try {
    return window.sessionStorage.getItem(`${DISMISSED_PREFIX}${key}`) === '1'
  } catch {
    return false
  }
}

export const dismissServiceNotice = (key: string): void => {
  try {
    window.sessionStorage.setItem(`${DISMISSED_PREFIX}${key}`, '1')
  } catch {
    // Storage blocked (private mode): the banner just closes for this page view.
  }
}
